<template>

	<div class="ak-login-forms">
		<transition name="el-fade-in-linear">
		<div class="ak-login-form" @keydown="enterLogin($event)" v-show="!forget">
			<div style="padding-bottom:70px;">
				<img src="../../assets/images/logo.png">
			</div>
			<div style="text-align:left; font-size:30px; font-weight: bold; font-family:times color:#191a32; padding-bottom: 58px;">
				<b>Log in</b>
			</div>
			
			<el-form :model="form" :rules='rules' ref="form">
				<el-form-item prop="Account">
					<!-- <el-input placeholder="Email" v-model="form.Account"></el-input> -->
					<input class="my-input" type="text" v-model="form.Account" placeholder="Email" />
				</el-form-item>
				
				<el-form-item prop="Password">
					<!-- <el-input placeholder="Password" type='password' v-model="form.Password"></el-input> -->
					<input class="my-input" type="password" v-model="form.Password" placeholder="Password" />
				</el-form-item>
				<br>

				<el-form-item prop="Captcha">
					<!-- <el-input ></el-input> -->
					<input class="my-input" type="text" v-model="form.Captcha" placeholder="Captcha" style="width:calc(100% - 100px);" />
					<canvas id="ctx" @click="setCap" title="click to reflash" style="vertical-align: bottom;cursor:pointer;"></canvas>
				</el-form-item>
				<el-form-item>
					<label class="files" style="float: right;padding-right: 10px; padding-bottom: 10px; cursor: pointer;" @click="openForget">Forget Password</label> 
				</el-form-item>
				<!-- <el-button round plain style="width: 100%;" type="primary" @click="login">Login</el-button> -->
				<div class="my-btn" @click="login">Login</div>
			</el-form>
		</div>
		</transition>

		<transition name="el-fade-in-linear">
		<div class="ak-login-form ak-login-form2" @keydown="enterSend($event)" v-show="forget">

			<div style="padding-bottom:70px;">
				<img src="../../assets/images/logo.png">
			</div>
			<div style="text-align:left; font-size:30px; font-weight: bold; font-family:times color:#191a32; padding-bottom: 58px;">
				<b>Forget Password</b>
			</div>
			
			<el-form :model="form2" :rules='rules' ref="form2">
				<el-form-item prop="Email">
					<!-- <el-input placeholder="Email" v-model="form.Account"></el-input> -->
					<input class="my-input" type="text" v-model="form2.Email" placeholder="Email" />
				</el-form-item>
		
				<!-- <el-button round plain style="width: 100%;" type="primary" @click="login">Login</el-button> -->
				<div class="my-btn" @click="send">Reset Password</div>
			</el-form>
		</div>
		</transition>
	</div>
</template>

<script>
import { createVerifCode } from "./cap.js";
export default{
    data () {
        let validateCaptcha = (self) =>{
            return (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('please enter verification code.'));
                }
				
                if(value !== self.captcha) {
                    return callback(new Error('Verification code input errors, please fill in  again.'));
                }
                return callback();
            };
        };
        return {
            form:{
                Account:"",
                Password:"",
                Captcha:""
            },
            form2:{
                Email:""
            },
            rules:{
                Account:[{ required: true, message: 'please input your email', trigger: 'blur' }],
                Password:[{required: true, message: 'Please enter a correct password', trigger: 'blur'}],
                Captcha:[{ validator: validateCaptcha(this), trigger: 'blur' }],
                Email:[{ required: true, message: 'Please input the email address', trigger: 'blur' },
                    { type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change'] }]
            },
            forget:false,
            captcha:""
        };
    },
    mounted () {
        this.setCap();
    },
    methods:{ 
        setCap () {
            this.captcha = createVerifCode("#ctx",100,54,4).join("");
        },
        login () {
            this.$refs.form.validate((valid)=>{
                if(!valid) {
                    return false;
                }
                this.$http.post('login',this.form,(data)=>{
                    localStorage.setItem("producttoken",data.Token);
                    localStorage.setItem("type",data.Type);
                    localStorage.setItem("grade",data.Grade);
                    localStorage.setItem("openOrder",data.OpenOrder);
                    this.$router.push("/");
                });
            });
            this.setCap();
        },
        enterLogin (ev) {
            if(ev.keyCode === 13)
                this.login();
        },
        openForget () {
            this.forget = !this.forget;
            this.form = {
                Account:"",
                Password:""
            };
        },
        send () {
            this.$refs.form2.validate((valid)=>{
                if(!valid) {
                    return false;
                }
                this.$http.post("sendFEmail",{
                    Email:this.form2.Email
                },()=>{
                });
            });
            this.$alert("The mail has been successfully sent to  "+this.form2.Email,"Success",{
                confirmButtonText: "OK",
                type: 'success'
            });
        },
        enterSend (ev) {
            if(ev.keyCode === 13)
                this.send();
        }
    }
};
</script>
<style lang="less">
	.ak-login-forms{
		position: relative;
		margin: 0 auto;
	}
	.ak-login-form{
		width: 372px;
		height: 592px;
		border: solid 1px gray;
		border-radius: 10px;
		
		padding: 36px 66px 50px 66px;
		background-color: white;
		
	}
	.ak-login-form2{
		margin-top: 80px;
		width: 372px;
		height: 452px;
		border: solid 1px gray;
		border-radius: 10px;
		
		padding: 36px 66px 50px 66px;
		background-color: white;
	}
	.my-input{
		width: 100%;
		height: 54px;
		outline: none;
		border: 1px solid #dadada;
		padding: 0 12px;
		font-size: 16px;
		box-sizing: border-box;
	}
	.files{
		font-size: 13px;
		color:#333333;
		text-decoration:underline;
		cursor: pointer;
		&:hover{
			color:#03a9f4;
		}
        } 
	.my-btn{
		height: 54px;
		color: #fff;
		background-color: #0182fa;
		font-size: 16px;
		line-height: 54px;
		text-align: center;
		cursor: pointer;
	}
	.my-btn:hover{
		background-color: #176fc1;
	}
	input::-webkit-input-placeholder{
		color:#909090;
	}
	input::-moz-placeholder{   /* Mozilla Firefox 19+ */
		color:#909090;
	}
	input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
		color:#909090;
	}
	input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
		color:#909090;
	}
</style>